<template>
  <div class="page-block">
    <header-bar v-if="isLoggedIn">ヘルプ</header-bar>
    <div class="page-block__heading page-block__heading--withbar">
      <h3 class="page-block__title">よくある質問</h3>
    </div>
    <div class="page-block__inner">
      <div class="faq-search-wrap">
        <div class="faq-search-text">検索</div>
        <input
          v-model="keyword"
          class="faq-search"
          type="search"
          @keydown.prevent.enter="onClickedSearch('enter',$event)">
        <a
          class="c-btn c-btn--search"
          @click.prevent="onClickedSearch('',$event)">
          <img
            src="/img/common/icon-search.png">検索
        </a>
      </div>
      <div
        class="faq-area">
        <div
          v-if="items.length > 0"
          class="faq-area-content">
          <h3 class="faq-area-title">{{ items[0].category.title }}</h3>

          <div class="faq-list">
            <template
              v-for="(item, index) in items">
              <p
                :key="item.id"
                class="faq-area-link">
                <router-link
                  :to="{ name: 'faq-detail', params: { id: item.id } }"
                  class="c-text-link">
                  {{ item.title }}
                </router-link>
              </p>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="c-btn-wrap c-btn-wrap-faq">
      <router-link
        :to="{ name: 'faq' }"
        class="c-btn c-btn--back">
        よくある質問へ戻る
        <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HeaderBar from '../HeaderBar'

export default {
  name: 'FaqIndexByCategory',
  components: { HeaderBar },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      items: [],
      keyword: '',
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
  },
  mounted() {
    this.fetchItem()
  },
  methods: {
    async fetchItem() {
      const { data } = await window.axios.get(`/api/client/faqs/category/${this.id}`)
      this.items = data
    },
    async onClickedSearch(type, event) {
      if (type === 'enter' && event.keyCode !== 13) return
      if (this.keyword) {
        this.$router.push({
          name: 'faq-search',
          query: {
            page: 1,
            keyword: this.keyword,
          },
        })
      }
    },
  },
}
</script>

<style scoped>
.faq-area-content{
  width: 100%;
}

.faq-list {
  display: block;
  width: 100%;
}

.faq-area-link {
  width: 100%;            /* 横幅を100%にして1カラムにする */
  box-sizing: border-box;
  padding-right: 0;       /* 1カラムなので右余白は不要（または適宜調整） */
}
</style>
